
import {
  solotionTabItems,
  PopularServices,
  questions,
  cdnCoverage,
  features,
  secureConnection,
} from "~/data/security";
import Modal from "../../components/rebranding/modal/Modal.vue";

export default {
  components: {
    Modal,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      title: "آبالون: ارائه دهنده سرویس‌های ابری",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      solotionTabItems,
      PopularServices,
      questions,
      cdnCoverage,
      features,
      secureConnection,
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      securitySections: [
        {
          key: "uses",
          label: "راهکارهای امنیت ابری",
          element: "#uses",
        },
        {
          key: "solutions",
          label: "دفاع چندلایه",
          element: "#solutions",
        },
        {
          key: "location",
          label: "پوشش و اثربخشی",
          element: "#location",
        },
        {
          key: "firewall",
          label: "امنیت به‌روز",
          element: "#firewall",
        },
        {
          key: "banner",
          label: "مشاوره و پشتیبانی",
          element: "#banner",
        },
        {
          key: "waf",
          label: "مقیاس‌پذیری",
          element: "#waf",
        },
        {
          key: "serviceFeatures",
          label: "امنیت سرویس‌های ابری",
          element: "#serviceFeatures",
        },
        {
          key: "PopularServices",
          label: "خدمات پرکاربرد",
          element: "#PopularServices",
        },
        {
          key: "faq",
          label: "سوالات متداول",
          element: "#faq",
        },
      ],
    };
  },
  head() {
    return {
      title: "امنیت ابری آبالون | محافظت یکپارچه از سرویس‌های سازمانی",
      meta: [
        {
          name: "description",
          content:
            "امنیت ابری آبالون |‌ بدون نیاز به سخت‌افزار‌ |‌ دفاع چند لایه سرویس‌های ابری سازمانی | جلوگیری از رخداد‌های امنیتی | راهکارهای WAF،DDoS و PAM ابری",
        },
        {
          name: "keywords",
          content: "امنیت ابری",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/cloud-security",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "امنیت ابری آبالون | محافظت یکپارچه از سرویس‌های سازمانی",
        },
        {
          property: "og:description",
          content:
            "امنیت ابری آبالون |‌ بدون نیاز به سخت‌افزار‌ |‌ دفاع چند لایه سرویس‌های ابری سازمانی | جلوگیری از رخداد‌های امنیتی | راهکارهای WAF،DDoS و PAM ابری",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/cloud-security",
        },
        {
          name: "twitter:creator",
          content: "@themetrades",
        },
        {
          name: "twitter:title",
          title: "امنیت ابری آبالون | محافظت یکپارچه از سرویس‌های سازمانی",
        },
        {
          name: "twitter:description",
          content:
            "امنیت ابری آبالون |‌ بدون نیاز به سخت‌افزار‌ |‌ دفاع چند لایه سرویس‌های ابری سازمانی | جلوگیری از رخداد‌های امنیتی | راهکارهای WAF،DDoS و PAM ابری",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/cloud-security",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "آیا امنیت ابری آبالون برای سرورهای داخل سازمان هم قابل استفاده است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، امنیت ابری آبالون به گونه‌ای طراحی شده که علاوه بر منابع مستقر در دیتاسنترهای آبالون، قابلیت اتصال و محافظت از سرورهای داخلی سازمان شما را نیز داراست و امنیت آن‌ها را تامین می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "چه نوع حملاتی توسط امنیت ابری آبالون شناسایی و دفع می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "امنیت ابری آبالون قادر است حملات حجمی، حملات لایه آپلیکیشن (Layer 7)، تزریق کد مثل SQL Injection و XSS، دسترسی‌های غیرمجاز و انواع تهدیدات سایبری رایج را شناسایی و دفع کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا مدیریت دسترسی کاربران در امنیت ابری آبالون امکان‌پذیر است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. با استفاده از سرویس PAM ابری و کنترل دسترسی مبتنی بر نقش، می‌توانید دسترسی‌های کاربران و حساب‌های حساس را به طور دقیق مدیریت کنید تا امنیت اطلاعات سازمان افزایش یابد.",
                },
              },
              {
                "@type": "Question",
                name: "پشتیبانی فنی امنیت ابری آبالون چگونه انجام می‌شود؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "پشتیبانی فنی امنیت ابری آبالون از طریق تیم تخصصی و به‌صورت ۲۴ ساعته انجام می‌شود تا در صورت بروز هرگونه تهدید یا رویداد امنیتی، سریعاً اقدامات لازم صورت گیرد.",
                },
              },
            ],
          },
        },

        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "امنیت ابری آبالون",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
};
